import classes from './_TokenTextContainer.module.css.js';
import { clsx } from 'clsx';
import { BoxWithFallback } from '../internal/components/BoxWithFallback.js';
import { jsx } from 'react/jsx-runtime';

const TokenTextContainer = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/jsx(BoxWithFallback, {
    as: "span",
    className: clsx(classes.TokenTextContainer),
    ...props,
    children: children
  });
};
TokenTextContainer.displayName = "TokenTextContainer";

export { TokenTextContainer as default };
